import { useCallback } from "react";
import { useNavigate } from "react-router";

import { WarningTriangleColored } from "components/icons/generated";
import SystemMessage from "components/SystemMessage";
import Box from "ds/components/Box";
import Button from "ds/components/Button";
import Typography from "ds/components/Typography";

import styles from "./styles.module.css";

type FedRampWarningProps = {
  onAcknowledge: () => void;
};

const FedRampWarning = ({ onAcknowledge }: FedRampWarningProps) => {
  const navigate = useNavigate();

  const handleLogout = useCallback(() => {
    navigate("/logout");
  }, [navigate]);

  return (
    <SystemMessage
      title="WARNING"
      message=""
      icon={WarningTriangleColored}
      cardClassName={styles.fedRampWarningCard}
    >
      <Box direction="column" gap="x-large" align="center">
        <Box direction="column" gap="medium">
          <Typography tag="p" variant="p-body3" align="center">
            This is a Spacelift FedRAMP environment provided for U.S. Government-authorized use
            only. Unauthorized use is prohibited.
          </Typography>
          <Typography tag="p" variant="p-body3" align="center">
            System usage may be monitored, recorded, and audited by authorized personnel. There is
            no reasonable expectation of privacy regarding any communication or data transiting or
            stored on this information system.
          </Typography>
          <Typography tag="p" variant="p-body3" align="center">
            Unauthorized or improper use of this system may result in disciplinary action, as well
            as civil and criminal penalties.
          </Typography>
          <Typography tag="p" variant="p-body3" align="center">
            By proceeding to use this system, you indicate your awareness of and consent to these
            terms and conditions of use.
          </Typography>
          <Typography tag="p" variant="p-body3" align="center">
            LOG OFF IMMEDIATELY if you do not agree to the conditions stated in this warning.
          </Typography>
        </Box>

        <Box gap="medium">
          <Button variant="secondary" onPress={handleLogout}>
            Log out
          </Button>
          <Button variant="primary" onPress={onAcknowledge}>
            Acknowledge and continue
          </Button>
        </Box>
      </Box>
    </SystemMessage>
  );
};

export default FedRampWarning;
